import { Component, Input, OnInit } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(TextareaInputComponent)]
})
export class TextareaInputComponent extends InputComponent implements OnInit {

  @Input() rows = 4;
  @Input() showWordCount = true;
  @Input() autoGrow = true;
  @Input() spellcheck = true;
  @Input() maxWidth: string;

  constructor() { super(); }

  ngOnInit() { }

  override checkValidity() {
    super.checkValidity();
    // if (this.isValid) {
    //   this.checkingValidity.emit(this);
    // }
  }
}
